module.exports = __webpack_public_path__ + "img/myd-bg.e32ddf4f.png";